import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const apiUrlHabitaciones = process.env.REACT_APP_API_HABITACIONES;
const apiUrlMiembrosPorHabitacion =
  process.env.REACT_APP_API_USUARIOS_HABITACIONES;

const BuscarMiembrosPorHabitacion = () => {
  const [habitaciones, setHabitaciones] = useState([]);
  const [habitacionSeleccionada, setHabitacionSeleccionada] = useState("");
  const [miembros, setMiembros] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar todas las habitaciones
  useEffect(() => {
    const fetchHabitaciones = async () => {
      try {
        const res = await axios.get(apiUrlHabitaciones);
        setHabitaciones(res.data);
      } catch (err) {
        console.error("❌ Error al cargar habitaciones:", err);
      }
    };
    fetchHabitaciones();
  }, []);

  // Buscar miembros al seleccionar habitación
  const handleChange = async (event) => {
    const habitacion_asignada = event.target.value; // es el número de habitación
    setHabitacionSeleccionada(habitacion_asignada);
    setLoading(true);
    try {
      const res = await axios.get(
        `${apiUrlMiembrosPorHabitacion}/${habitacion_asignada}`
      );
      setMiembros(res.data);
    } catch (err) {
      console.error("❌ Error al buscar miembros:", err);
      setMiembros([]);
    } finally {
      setLoading(false);
    }
  };
  const miembrosUnicos = Object.values(
    miembros.reduce((acc, curr) => {
      const dni = curr.dni;
      if (!acc[dni]) {
        acc[dni] = curr;
      } else {
        const actualRol = acc[dni].rol?.length || 0;
        const nuevoRol = curr.rol?.length || 0;
        if (nuevoRol > actualRol) {
          acc[dni] = curr;
        }
      }
      return acc;
    }, {})
  );

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Buscar miembros por habitación
      </Typography>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Seleccionar habitación</InputLabel>
        <Select
          value={habitacionSeleccionada}
          label="Seleccionar habitación"
          onChange={handleChange}
        >
          {habitaciones.map((hab) => (
            <MenuItem key={hab.id} value={hab.id}>
              Nº {hab.numero} - Piso {hab.piso}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {loading ? (
        <CircularProgress />
      ) : miembros.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>ID de la reserva</strong>
                </TableCell>
                <TableCell>
                  <strong>Federación</strong>
                </TableCell>
                <TableCell>
                  <strong>Nombre</strong>
                </TableCell>
                <TableCell>
                  <strong>Apellido</strong>
                </TableCell>
                <TableCell>
                  <strong>DNI</strong>
                </TableCell>
                <TableCell>
                  <strong>Rol</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {miembrosUnicos.map((m) => (
                <TableRow key={m.id}>
                  <TableCell>{m.reserva_id}</TableCell>
                  <TableCell>{m.federacion_deporte}</TableCell>
                  <TableCell>{m.nombre}</TableCell>
                  <TableCell>{m.apellido}</TableCell>
                  <TableCell>{m.dni}</TableCell>
                  <TableCell>{m.rol}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        habitacionSeleccionada && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            No hay miembros alojados en esta habitación.
          </Typography>
        )
      )}
    </Box>
  );
};

export default BuscarMiembrosPorHabitacion;
